import { render, staticRenderFns } from "./MenuNavegacionMovil.vue?vue&type=template&id=5fe44528&scoped=true&"
import script from "./MenuNavegacionMovil.vue?vue&type=script&lang=js&"
export * from "./MenuNavegacionMovil.vue?vue&type=script&lang=js&"
import style0 from "./MenuNavegacionMovil.vue?vue&type=style&index=0&id=5fe44528&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe44528",
  null
  
)

export default component.exports